<div [cdkTrapFocus]="picker.pickerMode !== 'inline'"
     class="dln-dt-container-inner">
    <dln-date-time-calendar
        *ngIf="pickerType === 'both' || pickerType === 'calendar'"
        class="dln-dt-container-row"
        [firstDayOfWeek]="picker.firstDayOfWeek"
        [(pickerMoment)]="pickerMoment"
        [selected]="picker.selected"
        [selecteds]="picker.selecteds"
        [selectMode]="picker.selectMode"
        [minDate]="picker.minDateTime"
        [maxDate]="picker.maxDateTime"
        [dateFilter]="picker.dateTimeFilter"
        [startView]="picker.startView"
        (calendarViewChange)="picker.calendarViewChange.emit($event)"
        (selectedChange)="dateSelected($event)"
        [eventMode]="picker.eventMode"
        [events]="picker.events"
    ></dln-date-time-calendar>

    <dln-date-time-timer
        *ngIf="pickerType === 'both' || pickerType === 'timer'"
        class="dln-dt-container-row"
        [pickerMoment]="pickerMoment"
        [minDateTime]="picker.minDateTime"
        [maxDateTime]="picker.maxDateTime"
        [showSecondsTimer]="picker.showSecondsTimer"
        [hour12Timer]="picker.hour12Timer"
        [stepHour]="picker.stepHour"
        [stepMinute]="picker.stepMinute"
        [stepSecond]="picker.stepSecond"
        (selectedChange)="timeSelected($event)"></dln-date-time-timer>

    <div *ngIf="picker.isInRangeMode"
         role="radiogroup"
         class="dln-dt-container-info dln-dt-container-row"
         (click)="toggleRangeActiveIndex()">
        <div role="radio"
             [attr.aria-checked]="activeSelectedIndex === 0"
             class="dln-dt-container-range dln-dt-container-from"
             [ngClass]="{'dln-dt-container-info-active': activeSelectedIndex === 0}">
            <span class="dln-dt-container-info-label">{{fromLabel}}:</span>
            <span class="dln-dt-container-info-value">{{fromFormattedValue}}</span>
        </div>
        <div role="radio"
             [attr.aria-checked]="activeSelectedIndex === 1"
             class="dln-dt-container-range dln-dt-container-to"
             [ngClass]="{'dln-dt-container-info-active': activeSelectedIndex === 1}">
            <span class="dln-dt-container-info-label">{{toLabel}}:</span>
            <span class="dln-dt-container-info-value">{{toFormattedValue}}</span>
        </div>
    </div>
    <div *ngIf="pickerType === 'calendar' && picker.pickerMode !== 'inline'" class="close-calendar-mobile" (click)="onCancelClicked($event)">
        <i class="icon-chevron-up"></i>
    </div>
    <div *ngIf="showControlButtons" class="dln-dt-container-buttons dln-dt-container-row">
        <button class="dln-dt-control-button dln-dt-container-control-button"
                type="button" tabindex="0" (click)="onCancelClicked($event)">
            <span class="dln-dt-control-button-content dln-dt-control-button-content-cancel" tabindex="-1">
                {{cancelLabel}}
            </span>
        </button>
        <button class="dln-dt-control-button dln-dt-container-control-button"
                type="button" tabindex="0" (click)="onSetClicked($event)">
            <span class="dln-dt-control-button-content dln-dt-control-button-content-set" tabindex="-1">
                {{setLabel}}
            </span>
        </button>
    </div>
</div>
